.ant-layout-header{font-weight:600;font-size:20px;background-color:#f4f4f6;background:#f4f4f6}nz-content{padding-left:50px;padding-right:50px}.care-plan-section{padding-top:64px}
/*# sourceMappingURL=health-care-plan-section.component-LDNHI4VJ.css.map */
